import HistoryItem from '@/ecm/models/search/results/list/HistoryItem'

export default class History {
    constructor (dto) {
        this.date = ''
        this.items = []

        if (dto) {
            this.date = dto.Date
            this.items = dto.Items.map(dto => new HistoryItem(dto))
        }
    }
}
